<template>
<div class="link-comment">
  <a :href="linkUrl" v-if="$pageType === 'entry'" data-cx-clickarea="comment-count-link">
    <div class="count-comment"><span>{{totalComment}}</span></div>
    <div class="read-comment">コメントを読む</div>
  </a>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'commentCountLink',
  data: function () {
    return {
      linkUrl: ''
    }
  },
  created: function () {
    this.linkUrl = location.href.replace(location.search, '').replace(location.hash, '') + '?ly=cm'
  },
  computed: {
    ...mapState('commentsData', ['commentsLength', 'commentsMaxLength']),
    totalComment: function () {
      return this.numberFormatter(this.commentsMaxLength)
    }
  },
  methods: {
    numberFormatter (num) {
      // k,Mのみ対応
      // 参考：https://stackoverflow.com/questions/9461621/how-to-format-a-number-as-2-5k-if-a-thousand-or-more-otherwise-900-in-javascrip
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
      }
      return num
    }
  }
}
</script>

<style lang="scss" src="./commentCountLink.scss"></style>



// WEBPACK FOOTER //
// src/components/molecules/commentCountLink/commentCountLink.vue